import { useState } from "react"

/**
 * Custom hook for managing filter state
 * @returns {Object} Filter state and handlers
 */
export const useUserFilters = () => {
  const [statusFilter, setStatusFilter] = useState([{ value: "all", label: "All Status" }])
  const [credentialsFilter, setCredentialsFilter] = useState([{ value: "all", label: "All Credentials" }])
  const [dateFilter, setDateFilter] = useState({ type: "preset", value: null })

  const handleStatusFilterChange = (values) => {
    setStatusFilter(values?.length ? values : [{ value: "all", label: "All Status" }])
  }

  const handleCredentialsFilterChange = (values) => {
    setCredentialsFilter(values?.length ? values : [{ value: "all", label: "All Credentials" }])
  }

  const handleDateFilterChange = (filter) => {
    setDateFilter(filter)
  }

  return {
    statusFilter,
    credentialsFilter,
    dateFilter,
    handleStatusFilterChange,
    handleCredentialsFilterChange,
    handleDateFilterChange
  }
}
